import axios from 'axios'
import store from '../../store/store'
import version from '../../util/version'
const instance = axios.create({
  baseURL: 'https://apitour.huayitraveltd.com/',
  // baseURL: 'http://192.168.1.178:8787/',
  timeout: 30000,
  headers: {
    'platform': 'web',
    'version': version
  }
})
const that = this
instance.interceptors.request.use(
  function (config) {
    const lang = store.state.lang
    config.headers['User-Type'] = store.state.userType
    config.headers['x-lang'] = lang ? (lang === 'zhCN' ? 'cn' : (lang === 'en' ? 'en' : 'hk')) : 'cn'
    if (store.getters.Vtoken && store.getters.Vtoken !== '') {
      config.headers.authorization = store.getters.Vtoken
    }
    return config
  }, function (error) {
    that.$notify.error('抱歉，我們遇到預期外的錯誤，請稍後再試!')
    console.log(error)
  }
)
instance.interceptors.response.use(function (response) {
  if (response.data.code === 300) {
    store.commit('delUserInfo')
    this.$alert('登錄超時')
  }
  return response
})
export const post = (uri, params, needResponseHeaders) => {
  needResponseHeaders = typeof needResponseHeaders !== 'boolean' ? false : needResponseHeaders
  params = typeof params === 'undefined' ? {} : params
  return new Promise((resolve, reject) => {
    instance.post(uri, {
      jwt: {},
      data: params
    }, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      if (needResponseHeaders) res.data._headers = res.headers
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export const get = (uri, params, needResponseHeaders) => {
  needResponseHeaders = typeof needResponseHeaders !== 'boolean' ? false : needResponseHeaders
  params = typeof params === 'undefined' ? {} : params
  return new Promise((resolve, reject) => {
    instance.get(uri, {
      params: params
    }).then(res => {
      if (needResponseHeaders) res.data._headers = res.headers
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export default {
  post,
  get
}



// WEBPACK FOOTER //
// ./src/service/util/http.js